import { clsx } from "clsx";
import styles from "./hidePanelButton.module.scss";
import { DownArrow } from "../SVGasComponent";
import { useStoreSystem } from "../../store";
import shallow from "zustand/shallow";


export const HidePanelButton = () => {
    const { settingsMenuIsVisible, setSystemProperties } = useStoreSystem(state => ({
        settingsMenuIsVisible: state.settingsMenuIsVisible,
        setSystemProperties: state.setSystemProperties,
    }), shallow);
    const handlerClick = () => {
        setSystemProperties([
            { name: 'settingsMenuIsVisible', value: !settingsMenuIsVisible },
        ])
    }
    return (
        <div className={styles.main} onClick={handlerClick}>
            <div className={clsx(styles.arrow, !settingsMenuIsVisible && styles.arrow_inverted)}>
                <DownArrow />
            </div>
        </div>
    )
}